import React from "react";
import Page from "../components/PageTemplate";
import ValuesText from "../data/TextAreaInput/ValueText";

const Values = () => {
  const titleSectionInput = {
    title: "",
    image: "values.png",
    bgTint1: "rgba(0, 37, 84, 0.2)",
    bgTint2: "rgba(0, 37, 84, 0.5)",
    bgTint3: "rgba(0, 37, 84, 0.8)",
  };
  return <Page titleSection={titleSectionInput} textArea={<ValuesText />} />;
};

export default Values;
